import React, { useMemo } from "react";
import useDialogManager from "@/utils/useDialogManager";
import styles from "./style/index.module.less";
import AvatarUI from "@/componentsUI/Avatar";
import BadgeUI from "@/componentsUI/Badge";
import { LockIcon, SettingsIcon } from "@/componentsUI/Icon";
import { useVipInfo } from "@/store/PersonalCenter";
import SvgNotice from "@/assets/svg-icon/SvgNotice";

import Svg2 from "./svg-icons/Lsjl";
import Svg3 from "./svg-icons/Qb";
import BonusCenter from "./svg-icons/BonusCenter";
import Svg5 from "./svg-icons/Tc";
import Svg6 from "./svg-icons/Vip";
import Svg7 from "./svg-icons/Yqhy";
import Svg9 from "./svg-icons/Ar";

import { useNavigate } from "react-router";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import {
  AmountDivisorConversion,
  dealAmount0Fiexd,
  numberFixed,
} from "@/Core/utils/currencyDealCenter";

import { getAvatarUrl } from "@/utils/avatar";
import copy from "copy-to-clipboard";
import { debounce } from "@/Core/utils";
import {
  useGlobalOpenUserCenter,
  useGlobalState,
  useGlobalWalletStore,
} from "@/store/commonStore";
import { useSignOut } from "@/store/signin";
import { Yaoqing } from "@/assets/svg-icon";
import { clearNoticeMessage } from "@/store/message";
import { clearBonusMyAwardListPlus } from "@/store/bonus";
import CurrencyComponent from "@/components/currencyComponent";
import { useWalletAll } from "@/store/walletStore";
import { feedback } from "@/utils/feedback";

type IProps = {
  handleColes?: () => void;
  hasBonusRedDot?: boolean;
  onBonusRedDotSeen?: () => void;
};

const WalletTabIndex = {
  Deposit: 0,
  Swap: 1,
} as const;

const Droplist = ({
  handleColes,
  hasBonusRedDot = false,
  onBonusRedDotSeen,
}: IProps) => {
  const {
    openVip,
    openHistoryElement,
    openAuditRecords,
    openSharePage,
    openDialogNotice,
    openWallet,
  } = useDialogManager();
  const { t } = useTranslationPlus("droplist");
  const { t: tHome } = useTranslationPlus("HomeView");
  const { t: tt } = useTranslationPlus("GoogleSecurity");
  const { t: tInvite } = useTranslationPlus("inviteElement");
  const navigate = useNavigate();
  const { data } = useVipInfo();
  const [visible, setVisible] = useGlobalOpenUserCenter();
  const { trigger } = useSignOut();
  const { setToken, setTokenTime } = useGlobalState();
  const { data: walletData } = useWalletAll(false);
  const [globalWallet] = useGlobalWalletStore();

  // 查找法币和FUN币种数据
  // 法币钱包：currencyCategory === 2
  const kshWallet = useMemo(() => {
    return (
      globalWallet?.all?.find((wallet) => wallet.currencyCategory === 2) || null
    );
  }, [globalWallet]);

  const funWallet = useMemo(() => {
    return (
      globalWallet?.all?.find((wallet) => wallet.currencyType === "FUN") || null
    );
  }, [globalWallet]);

  // 点击KSH打开充值界面
  const handleClickKSH = () => {
    void openWallet({ tabIndex: WalletTabIndex.Deposit });
    handleColes && handleColes();
    setVisible(false);
  };

  // 点击FUN打开SWAP界面
  const handleClickFUN = () => {
    void openWallet({ tabIndex: WalletTabIndex.Swap });
    handleColes && handleColes();
    setVisible(false);
  };

  const handleClickVip = () => {
    openVip();
  };

  const handleClickWallet = () => {
    void openWallet({ tabIndex: WalletTabIndex.Deposit });
    handleColes && handleColes();
    setVisible(false);
  };

  const handleClickRecords = () => {
    openHistoryElement();
  };
  const handleClickAudit = () => {
    openAuditRecords();
  };
  const handleClickInvite = () => {
    openSharePage();
  };
  const handleClickNotice = () => {
    openDialogNotice();
    handleColes && handleColes();
    setVisible(false);
  };
  const handleClickBonus = () => {
    onBonusRedDotSeen?.();
    navigate("/bonus");
    handleColes && handleColes();
    setVisible(false);
  };

  const handleFirends = () => {
    navigate("/NationalProxy");
    handleColes();
    setVisible(false);
  };

  const useClickLogout = () => {
    trigger({});
    setToken("");
    setTokenTime("");
    navigate("/");
    clearNoticeMessage();
    clearBonusMyAwardListPlus();
  };

  // 安全中心
  const ClickGlobalSettings = () => {
    navigate("/globalSettings/0");
    handleColes();
    setVisible(false);
  };

  const calcCurrentProGress = () => {
    /*  进度=当前已获得 /  （下一等级总经验-当前等级总经验）
         *达到到当前等级后 后台需把已获得经验清空
             如：
        */
    const levelTotalExp = AmountDivisorConversion(data?.levelTotalExp, {
      currencyType: data?.currencyType,
    }); //当前等级经验
    const totalExp = AmountDivisorConversion(data?.totalExp, {
      currencyType: data?.currencyType,
    }); //当前已获得经验
    const nextLevelTotalExp = AmountDivisorConversion(data?.nextLevelTotalExp, {
      currencyType: data?.currencyType,
    }); //下一等级需要经验
    const per = (totalExp / (nextLevelTotalExp - levelTotalExp)) * 100;
    // return parseFloat(numberFixed(per > 100 ? 100 : per, 0)?.replace(',', '.')); //兼容服务端数据错误，百分比》100%
    return Math.round(per > 100 ? 100 : per);
  };

  /* 复制回调 */
  const handlerCopy = debounce(() => {
    if (copy(data?.usrId)) {
      feedback.success(tInvite("INVITE-1"));
    }
  });

  // useEffect(() => {
  //   revalidate();
  // }, []);

  const nextLevelTotalExp = useMemo(() => {
    if (!data) {
      return 0.0;
    }
    return numberFixed(
      AmountDivisorConversion(data?.nextLevelTotalExp, {
        currencyType: data?.currencyType,
      }) -
        AmountDivisorConversion(data?.levelTotalExp, {
          currencyType: data?.currencyType,
        }) -
        AmountDivisorConversion(data?.totalExp, {
          currencyType: data?.currencyType,
        })
    );
  }, [data]);

  const avatarUrl = getAvatarUrl(data?.usrId ?? data?.userName, 80);

  return (
    <div className={styles.bubbleCardContainer}>
      {/* <MyIconClose onClick={handleColes}></MyIconClose> */}
      <div className={styles.header}>
        <div className={styles.myAvatar} data-level-text={`V${data?.level}`}>
          <AvatarUI>
            <img alt={""} src={avatarUrl} />
          </AvatarUI>
        </div>
        <div className={styles.name}>{data?.userName || ""}</div>
        <div className={styles.userId} onClick={handlerCopy}>
          {tt("User ID")}:<a className={styles.number}>{data?.usrId}</a>
        </div>

        {/* 添加KSH和FUN COINS显示 */}
        <div className={styles.walletCardsContainer}>
          <div className={styles.walletCard} onClick={handleClickKSH}>
            <div className={styles.walletCardTitle}>
              <CurrencyComponent
                currencyType={kshWallet?.currencyType}
                serverCurrencyType={kshWallet?.serverCurrencyType}
              />
            </div>
            <div className={styles.walletCardAmount}>
              <CurrencyComponent
                amount={kshWallet?.allBalance}
                type={"valid9"}
                showIcon={false}
                showUnit={false}
                currencyType={kshWallet?.currencyType}
                serverCurrencyType={kshWallet?.serverCurrencyType}
              />
            </div>
          </div>
          <div className={styles.walletCard} onClick={handleClickFUN}>
            <div className={styles.walletCardTitle}>
              <CurrencyComponent
                currencyType={funWallet?.currencyType}
                serverCurrencyType={funWallet?.serverCurrencyType}
              />
            </div>
            <div className={styles.walletCardAmount}>
              <CurrencyComponent
                amount={funWallet?.allBalance}
                type={"valid9"}
                showIcon={false}
                showUnit={false}
                currencyType={funWallet?.currencyType}
                serverCurrencyType={funWallet?.serverCurrencyType}
              />
                  {funWallet?.lockMoney > 0 && (
                    <div className={styles.walletLockMoney}>
                      <LockIcon />
                  <CurrencyComponent
                    amount={funWallet?.lockMoney}
                    type={"valid9"}
                    showIcon={false}
                    showUnit={false}
                    currencyType={funWallet?.currencyType}
                    serverCurrencyType={funWallet?.serverCurrencyType}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className={styles.vip} onClick={openVip}>
          <span>VIP{data?.level || 0}</span>
          <span>
            <span className={styles.exp}>{nextLevelTotalExp}</span>
            {t("DROPLIST-8")}
            {data?.nextLevel || 0}
          </span>
        </div>
      </div>
      <div className={styles.main}>
        {/* 进度条 */}
        <div className={styles.scheduleBox}>
          <div
            className={styles.schedule}
            style={{ '--progress-width': `${calcCurrentProGress() || 0}%` } as React.CSSProperties}
          ></div>
          <div className={styles.scheduleText}>{calcCurrentProGress() || 0}%</div>
        </div>
        {/* 钱包、历史记录 */}
        <div className={styles.mainItem}>
          <div className={styles.menuItem} onClick={handleClickWallet}>
            <Svg3 />
            <span>{t("DROPLIST-1")}</span>
          </div>
          <div className={styles.menuItem} onClick={handleClickRecords}>
            <Svg2 />
            <span>{t("DROPLIST-2")}</span>
          </div>
          <div className={styles.menuItem} onClick={handleClickNotice}>
            <SvgNotice />
            <span>{tHome("MessageNotice")}</span>
          </div>
          <div className={styles.menuItem} onClick={handleClickBonus}>
            <BadgeUI
              count={hasBonusRedDot ? 1 : 0}
              dot
              className={styles.menuBadge}
            >
              <BonusCenter />
            </BadgeUI>
            <span>{t("DROPLIST-10")}</span>
          </div>
          <div className={styles.menuItem} onClick={handleClickAudit}>
            <Svg9 />
            <span>{t("DROPLIST-9")}</span>
          </div>
          <div className={styles.menuItem} onClick={handleFirends}>
            <Yaoqing />
            <span>{t("DROPLIST-5")}</span>
          </div>
          <div className={styles.menuItem} onClick={handleClickVip}>
            <Svg6 />
            <span>{t("DROPLIST-3")}</span>
          </div>
          <div className={styles.menuItem} onClick={handleClickInvite}>
            <Svg7 />
            <span>{t("DROPLIST-4")}</span>
              </div>
              <div className={styles.menuItem} onClick={ClickGlobalSettings}>
                <SettingsIcon />
                <span>{tt("Global Settings")}</span>
              </div>
        </div>
      </div>
      <div className={styles.logOut} onClick={useClickLogout}>
        <Svg5 />
        <span>{t("DROPLIST-7")}</span>
      </div>
    </div>
  );
};

export default Droplist;
